var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category',{attrs:{"name":"Potion Effects","categorystyle":"potion_effects_category"}},[_c('block',{attrs:{"type":"apply_potion_effect"}}),_c('block',{attrs:{"type":"clear_all_potion_effects"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }